export default {"src":"/_next/static/media/icecream.6e1c8ab6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};